import { User } from './../../home/models/home';
import { ResultboradDraft, RosterPosition, LeagueScore, MiniLobbyScore, GamePosition, BestBallPickCount,
        TournamentMiniLobbyScore, SoundToggle, DraftTurn, DeafultRank, PickedPlayers, PickNumber, PlayersList, DraftStatus, CurrentTournament, MobileScreen, AuthUser, UserBalance, initialState, DraftPositions, AutoDraftEnable, ByeWeek,DarkMode } from './../../resultboard/model/resultboard';
import { Draft, DraftScore } from './../../resultboard/draft/model/draft';
import { myTeamList } from './../../_models/index';

import { Actions, USER_LOGIN, USER_LOGOUT, LEAGUE_DATA, LEAGUE_ID, LEAGUE_SCORE_DATA, MY_TEAM_DATA, SCORE_DATA, ROSTER_DATA, MINI_LOBBY_DATA,
    GAME_POSITION_DATA, BEST_BALL_PICK_COUNT, TOURNAMENT_MINI_LOBBY_DATA, SOUND_TOGGLE, DRAFT_TURN, DEAFULT_RANK_TOGGLE, PICKED_PLAYERS, PICK_NUMBER, PLAYERS_LIST_DATA, DRAFT_STATUS_DATA, CURRENT_TOURNAMENT_DATA, MOBILE_SCREEN, AUTH_USER, LOG_OUT, LOG_IN, DRAFT_POSITIONS, AUTO_DRAFT_ENABLE, BYE_WEEK,DarkModeAction, DARK_MODE, USER_BALANCE } from './../../store/actions/appActions';

export function reducer(
    state: User[] = [],
    action: Actions) {

    switch (action.type) {
        case USER_LOGIN:
            return [action.payload];

        case USER_LOGOUT:
            return state.filter(({ user_id }) => user_id !== action.user_id);

        default:
            return state;
    }
}

export function leaguereducer(
    state: ResultboradDraft[] = [],
    action: Actions) {

    switch (action.type) {
        case LEAGUE_ID:

            return [action.payload];

        default:
            return state;
    }
}

export function draftReducer(
    state: Draft[] = [],
    action: Actions) {

    switch (action.type) {
        case LEAGUE_DATA:

            return [action.payload];

        default:
            return state;
    }
}

export function draftScoreReducer(
    state: DraftScore[] = [],
    action: Actions) {

    switch (action.type) {
        case LEAGUE_SCORE_DATA:

            return [action.payload];

        default:
            return state;
    }
}


export function myTeamReducer(
    state: myTeamList[] = [],
    action: Actions) {

    switch (action.type) {
        case MY_TEAM_DATA:

            return [action.payload];

        default:
            return state;
    }
}

export function rosterPositionReducer(
    state: RosterPosition[] = [],
    action: Actions) {

    switch (action.type) {
        case ROSTER_DATA:
            return [action.payload];
        default:
            return state;
    }
}

export function leagueScoreReducer(
    state: LeagueScore[] = [],
    action: Actions) {

    switch (action.type) {
        case SCORE_DATA:
            return [action.payload];
        default:
            return state;
    }
}

export function joinDarftMiniLobbyReducer(
    state: MiniLobbyScore[] = [],
    action: Actions) {

    switch (action.type) {
        case MINI_LOBBY_DATA:
            return [action.payload];
        default:
            return state;
    }
}

export function joinTournamentMiniLobbyReducer(
    state: TournamentMiniLobbyScore[] = [],
    action: Actions) {

    switch (action.type) {
        case TOURNAMENT_MINI_LOBBY_DATA:
            return [action.payload];
        default:
            return state;
    }
}

export function gamePositionFilters(
    state: GamePosition[] = [],
    action: Actions) {

    switch (action.type) {
        case GAME_POSITION_DATA:
            return [action.payload];
        default:
            return state;
    }
}

export function bestBallPickedCount(
    state: BestBallPickCount[] = [],
    action: Actions) {

    switch (action.type) {
        case BEST_BALL_PICK_COUNT:
            return [action.payload];
        default:
            return state;
    }
}

export function soundOnOff(
    state: SoundToggle[] = [],
    action: Actions) {

    switch (action.type) {
        case SOUND_TOGGLE:
            return [action.payload];
        default:
            return state;
    }
}

export function setDeafultRank(
    state: DeafultRank[] = [],
    action: Actions) {

    switch (action.type) {
        case DEAFULT_RANK_TOGGLE:
            return [action.payload];
        default:
            return state;
    }
}

export function userDraftTurn(
    state: DraftTurn[] = [],
    action: Actions) {

    switch (action.type) {
        case DRAFT_TURN:
            return [action.payload];
        default:
            return state;
    }
}

export function pickedPlayerList(
    state: PickedPlayers[] = [],
    action: Actions) {

    switch (action.type) {
        case PICKED_PLAYERS:
            return [action.payload];
        default:
            return state;
    }
}

export function currentPickNumber(
    state: PickNumber[] = [],
    action: Actions) {

    switch (action.type) {
        case PICK_NUMBER:
            return [action.payload];
        default:
            return state;
    }
}

export function playersListReducer(
    state: PlayersList[] = [],
    action: Actions) {

    switch (action.type) {
        case PLAYERS_LIST_DATA:

            return [action.payload];

        default:
            return state;
    }
}

export function changeInDraft(
    state: DraftStatus[] = [],
    action: Actions) {

    switch (action.type) {
        case DRAFT_STATUS_DATA:

            return [action.payload];

        default:
            return state;
    }
}

export function currTournamentData(
    state: CurrentTournament[] = [],
    action: Actions) {

    switch (action.type) {
        case CURRENT_TOURNAMENT_DATA:

            return [action.payload];

        default:
            return state;
    }
}

export function mobileScreenData(
    state: MobileScreen[] = [],
    action: Actions) {

    switch (action.type) {
        case MOBILE_SCREEN:

            return [action.payload];

        default:
            return state;
    }
}

export function anthUserData(
    state: AuthUser[] = [],
    action: Actions) {

    switch (action.type) {
        case AUTH_USER:

            return [action.payload];

        default:
            return state;
    }
} 

export function userBalanceData(
    state: UserBalance[] = [],
    action: Actions) {

    switch (action.type) {
        case USER_BALANCE:

            return [action.payload];

        default:
            return state;
    }
} 

export function reducerUser(state = initialState, action: Actions) {
    switch (action.type) {
        case LOG_OUT: {
            return {
                ...state,
                isLoggedIn: false
            }
        }

        case LOG_IN: {
            return {
                ...state,
                isLoggedIn: true
            }
        }

        default: {
            return state;
        }
    }
}

export function positionsRemovedData(
    state: DraftPositions[] = [],
    action: Actions) {

    switch (action.type) {
        case DRAFT_POSITIONS:

            return [action.payload];

        default:
            return state;
    }
}

export function isAutoDraftEnable(
    state: AutoDraftEnable[] = [],
    action: Actions) {

    switch (action.type) {
        case AUTO_DRAFT_ENABLE:

            return [action.payload];

        default:
            return state;
    }
}

export function byeWeekList(
    state: ByeWeek[] = [],
    action: Actions) {

    switch (action.type) {
        case BYE_WEEK:

            return [action.payload];

        default:
            return state;
    }
}


export function DarkModeReducer(
    state: DarkMode[]= [],
    action: Actions) {

    switch (action.type) {
        case DARK_MODE:
            return [action.payload];

        default:
            return state;
    }
}